import * as React from 'react';
import { ReactComponent as EditIconSVG } from '../../assets/icons/mevo/ic_edit.svg';
import IconPattern, { IconProps } from './_IconPattern';

const EditIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={EditIconSVG} variantPlaces={2} {...props} />;
};

export default EditIcon;
